import React from 'react'
import { UserAuth } from '../../../middleware/UserContext/UserContext.middleware'

import AdvertListPage from '../../screens/AdvertsListPage/AdvertsListPage.component'
import LoginPage from '../../screens/LoginPage/LoginPage.component'

const Home: React.FC = () => {
  const { currentUser } = UserAuth()

  if (currentUser) return <AdvertListPage />

  return (<LoginPage />)
}

export default Home
